export function PosterIcon({ name, color = "currentColor" }) {
    const props = {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
    };
    switch (name) {
        case "heart":
            return (
                <svg {...props}>
                    <path d="M12 20s-7-4.4-7-9.2A4 4 0 0 1 12 7a4 4 0 0 1 7 3.8C19 15.6 12 20 12 20z" />
                </svg>
            );
        case "star":
            return (
                <svg {...props}>
                    <path d="m12 3 2.4 5.3 5.8.7-4.3 3.9 1.2 5.7L12 16.5 6.9 18.6l1.2-5.7-4.3-3.9 5.8-.7z" />
                </svg>
            );
        case "shield":
            return (
                <svg {...props}>
                    <path d="M12 3 5 6v6c0 4.2 2.9 7.4 7 8.5 4.1-1.1 7-4.3 7-8.5V6z" />
                    <path d="m9 12 2 2 4-4" />
                </svg>
            );
        case "sparkle":
            return (
                <svg {...props}>
                    <path d="M12 3v4M12 17v4M4.5 12h4M15.5 12h4M7 7l2.2 2.2M14.8 14.8 17 17M17 7l-2.2 2.2M9.2 14.8 7 17" />
                </svg>
            );
        case "handshake":
            return (
                <svg {...props}>
                    <path d="M8 13 5.5 10.5a2 2 0 0 1 0-2.8L8 5.2l3 3 3-3 2.5 2.5a2 2 0 0 1 0 2.8L14 13" />
                    <path d="m10 11 2 2 2-2" />
                    <path d="M8 13v5M16 13v5" />
                </svg>
            );
        case "leaf":
            return (
                <svg {...props}>
                    <path d="M5 19c8-1 13-8 14-14-6 1-13 6-14 14z" />
                    <path d="M8 16c2-3 5-6 8-8" />
                </svg>
            );
        case "chat":
            return (
                <svg {...props}>
                    <path d="M5 6h14v9H9l-4 3z" />
                </svg>
            );
        case "building":
        default:
            return (
                <svg {...props}>
                    <path d="M4 20V8l8-4 8 4v12" />
                    <path d="M9 20v-6h6v6" />
                    <path d="M9 11h.01M15 11h.01M12 11h.01" />
                </svg>
            );
    }
}

export function BrandMark({ color = "#C6A15B" }) {
    return (
        <svg
            className="print-poster__mark"
            viewBox="0 0 72 48"
            aria-hidden="true"
        >
            <path
                d="M8 36c8-16 16-24 28-24s20 8 28 24"
                fill="none"
                stroke={color}
                strokeWidth="2.4"
                strokeLinecap="round"
            />
            <path
                d="M16 36c6-12 12-18 20-18s14 6 20 18"
                fill="none"
                stroke={color}
                strokeWidth="2.4"
                strokeLinecap="round"
            />
            <path
                d="M24 36c4-8 8-12 12-12s8 4 12 12"
                fill="none"
                stroke={color}
                strokeWidth="2.4"
                strokeLinecap="round"
            />
        </svg>
    );
}

export function PlaceholderQr() {
    return (
        <svg
            className="print-poster__qr-placeholder"
            viewBox="0 0 29 29"
            aria-hidden="true"
        >
            <rect width="29" height="29" fill="var(--poster-qr-bg, #fff)" />
            {[
                [0, 0],
                [22, 0],
                [0, 22],
            ].map(([x, y]) => (
                <g key={`${x}-${y}`}>
                    <rect
                        x={x}
                        y={y}
                        width="7"
                        height="7"
                        fill="var(--poster-qr-fg, #111)"
                    />
                    <rect
                        x={x + 1}
                        y={y + 1}
                        width="5"
                        height="5"
                        fill="var(--poster-qr-bg, #fff)"
                    />
                    <rect
                        x={x + 2}
                        y={y + 2}
                        width="3"
                        height="3"
                        fill="var(--poster-qr-fg, #111)"
                    />
                </g>
            ))}
            {[2, 4, 8, 10, 12, 14, 16, 18, 20, 24, 26].map((x, i) => (
                <rect
                    key={x}
                    x={x}
                    y={10 + ((i * 3) % 9)}
                    width="2"
                    height="2"
                    fill="var(--poster-qr-fg, #111)"
                />
            ))}
            <rect x="12" y="4" width="2" height="2" fill="var(--poster-qr-fg, #111)" />
            <rect x="16" y="4" width="2" height="2" fill="var(--poster-qr-fg, #111)" />
            <rect x="20" y="8" width="2" height="2" fill="var(--poster-qr-fg, #111)" />
            <rect x="24" y="16" width="2" height="2" fill="var(--poster-qr-fg, #111)" />
            <rect x="10" y="20" width="2" height="2" fill="var(--poster-qr-fg, #111)" />
            <rect x="14" y="22" width="2" height="2" fill="var(--poster-qr-fg, #111)" />
            <rect x="18" y="24" width="2" height="2" fill="var(--poster-qr-fg, #111)" />
            <rect x="22" y="22" width="2" height="2" fill="var(--poster-qr-fg, #111)" />
            <rect x="12" y="16" width="4" height="4" fill="var(--poster-qr-fg, #111)" />
        </svg>
    );
}
